/**
 * "Team & roles" — Dashboard section (ADR-0074).
 * Reconciled from members.graphql (the five-role ladder) + apps/web team feature.
 */
import type { DocPageContent } from '../types';

export const DASHBOARD_TEAM_PAGE: DocPageContent = {
  slug: 'dashboard/team',
  titleKey: 'docs.dashboard.team.title',
  descriptionKey: 'docs.dashboard.team.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.team.lead' },

    { kind: 'heading', level: 2, id: 'roles', textKey: 'docs.dashboard.team.roles.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.team.role.owner',
        'docs.dashboard.team.role.admin',
        'docs.dashboard.team.role.editor',
        'docs.dashboard.team.role.reviewer',
        'docs.dashboard.team.role.viewer',
      ],
    },

    { kind: 'heading', level: 2, id: 'matrix', textKey: 'docs.dashboard.team.matrix.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.team.matrix.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.dashboard.team.matrix.item.view.term',
          descKey: 'docs.dashboard.team.matrix.item.view.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.edit.term',
          descKey: 'docs.dashboard.team.matrix.item.edit.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.promote.term',
          descKey: 'docs.dashboard.team.matrix.item.promote.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.audit.term',
          descKey: 'docs.dashboard.team.matrix.item.audit.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.export.term',
          descKey: 'docs.dashboard.team.matrix.item.export.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.keys.term',
          descKey: 'docs.dashboard.team.matrix.item.keys.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.team.term',
          descKey: 'docs.dashboard.team.matrix.item.team.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.billing.term',
          descKey: 'docs.dashboard.team.matrix.item.billing.desc',
        },
        {
          termKey: 'docs.dashboard.team.matrix.item.owner.term',
          descKey: 'docs.dashboard.team.matrix.item.owner.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.team.matrix.note.title',
      textKey: 'docs.dashboard.team.matrix.note.body',
    },

    { kind: 'heading', level: 2, id: 'managing', textKey: 'docs.dashboard.team.managing.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.team.managing.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.dashboard.team.guardrails.title',
      textKey: 'docs.dashboard.team.guardrails.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.team.next.settings.title',
          textKey: 'docs.dashboard.team.next.settings.text',
          to: { docSlug: 'dashboard/settings' },
        },
        {
          titleKey: 'docs.dashboard.team.next.identity.title',
          textKey: 'docs.dashboard.team.next.identity.text',
          to: { docSlug: 'identity' },
        },
      ],
    },
  ],
};
